import { styled } from '@grupoboticario/flora-react-system'

const labelBlurStyles = {
  '&:before': {
    top: '2px',
  },
}

export const StyledLabel = styled('label', {
  display: 'flex',
  fontFamily: 'inherit',
  fontSize: '$bodyLarge',
  lineHeight: '$shorter',
  fontWeight: '$medium',
  verticalAlign: 'middle',
  width: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',

  variants: {
    status: {
      neutral: {},
      success: {},
      error: {},
      warning: {},
      loading: {},
    },
    hasLeftIcon: {
      true: {},
    },
    hasRightIcon: {
      true: {},
    },
    labelPosition: {
      internal: {
        position: 'absolute',
        zIndex: '1',
        top: '1px',
        left: '0px',
        padding: '1.3125rem $4 0',
        transitionDuration: '300ms',
        transitionTimingFunction: 'ease-out',

        '> span': {
          position: 'relative',
        },
      },
      external: {
        fontSize: '$bodySmall',
        lineHeight: '1.1428571429',
        marginBottom: '$2',
      },
    },
    surfaceColor: {
      light: {},
      dark: {},
    },
    disabled: { true: {} },
  },
  compoundVariants: [
    {
      status: 'success',
      labelPosition: 'internal',
      css: labelBlurStyles,
    },
    {
      status: 'error',
      labelPosition: 'internal',
      css: labelBlurStyles,
    },
    {
      status: 'warning',
      labelPosition: 'internal',
      css: labelBlurStyles,
    },
    {
      status: 'loading',
      labelPosition: 'internal',
      css: labelBlurStyles,
    },

    {
      disabled: true,
      surfaceColor: 'light',
      css: {
        color: '$disabledContent',
      },
    },
    {
      disabled: true,
      surfaceColor: 'dark',
      css: {
        color: '$disabledAltContent',
      },
    },
    {
      disabled: false,
      surfaceColor: 'light',
      css: {
        color: '$nonInteractivePredominant',
      },
    },
    {
      disabled: false,
      surfaceColor: 'dark',
      css: {
        color: '$nonInteractiveAltPredominant',
      },
    },

    {
      labelPosition: 'internal',
      hasLeftIcon: true,
      css: {
        width: 'calc(100% - $12)',
        paddingLeft: '$12',
      },
    },
    {
      labelPosition: 'internal',
      hasRightIcon: true,
      css: {
        width: 'calc(100% - $12)',
        paddingRight: '$12',
      },
    },
  ],
})

export const StyledInternalPlaceholder = styled('span', {
  color: '$nonInteractiveAuxiliar',
  fontSize: '$bodyLarge',
  fontWeight: '$regular',
  lineHeight: '$shorter',
  marginLeft: '$2',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-out',

  variants: {
    surfaceColor: {
      light: {
        color: '$nonInteractiveAuxiliar',
      },
      dark: {
        color: '$nonInteractiveAltAuxiliar',
      },
    },
  },
})

export const StyledRequired = styled('span', {
  display: 'inline-flex',
  marginLeft: '$1',

  variants: {
    surfaceColor: {
      light: {
        color: '$statusErrorNonInteractiveEmphasis',
      },
      dark: {
        color: '$statusErrorNonInteractiveAltEmphasis',
      },
    },
  },
})

export const StyledTooltip = styled('span', {
  marginLeft: '$1',
})
